module.exports = __webpack_public_path__ + "img/homeSlide_v3_final.24a467c5.png";